<template>
  <Badge variant="success" size="sm" ring :icon="CheckIcon">
    <slot />
  </Badge>
</template>

<script lang="ts" setup>
import Badge from '@/components/Badge.vue';
import { CheckIcon } from 'lucide-vue-next';
</script>
